import { Spinner } from '@/shared/ui/atoms'

const Loading = () => {
  return (
    <section className="fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center z-[102]">
      <div className="bg-black/50 w-full h-full absolute top-0 left-0"/>
      <Spinner size={42} />
    </section>
  )
}

export default Loading